<template>
  <div>
    <b-card class="mb-3">
      <b-tabs
        fill
        nav-class="border-0"
        class="mb-3"
        :value="tabActive"
        @input="tabsChanged"
      >
        <b-tab title="برنامه">
          <b-card class="mb-3">
            <loading v-if="customAppsLoading" />
            <error-messages
              v-if="!customAppsLoading && customAppsErrorMessages.length > 0"
              :show="true"
              :message="customAppsErrorMessages"
            />
            <b-card-group deck class="card-deck-app">
              <card-app
                v-for="app in customAppsList"
                :key="app.id"
                :selected="app.selected"
                :id="app.id"
                :title="app.name"
                :srcImage="app.picture"
                @click="selectAppClicked"
              />
            </b-card-group>
          </b-card>
          <b-card
            class="mb-3"
            v-if="
              customAppsSelectedItem &&
                customAppsSelectedItem.versions &&
                customAppsSelectedItem.versions.length > 0
            "
          >
            <template #header>
              <h4 class="m-0">
                نسخه برنامه
              </h4>
            </template>
            <main-text>
              در زیر می توانید نسخه برنامه خود را انتخاب کنید.
            </main-text>
            <b-form-radio-group
              :checked="customAppsSelectedVersion"
              :options="customAppsSelectedItem.versions"
              value-field="id"
              text-field="version"
              @input="customAppsSelectedVersionChanged"
            ></b-form-radio-group>
          </b-card>
        </b-tab>
        <b-tab title="برنامه های آماده">
          <b-card class="mb-3">
            <loading v-if="readyAppsLoading" />
            <error-messages
              v-if="!readyAppsLoading && readyAppsErrorMessages.length > 0"
              :show="true"
              :message="readyAppsErrorMessages"
            />
            <b-card-group v-else deck class="card-deck-app">
              <card-app
                v-for="app in readyAppsList"
                :key="app.id"
                :selected="app.selected"
                :id="app.id"
                :title="app.name"
                :srcImage="app.picture"
                @click="selectAppClicked"
              />
            </b-card-group>
          </b-card>
          <b-card
            class="mb-3"
            v-if="
              readyAppsSelectedItem &&
                readyAppsSelectedItem.versions &&
                readyAppsSelectedItem.versions.length > 0
            "
          >
            <template #header>
              <h4 class="m-0">
                نسخه برنامه
              </h4>
            </template>
            <main-text>
              در زیر می توانید نسخه برنامه خود را انتخاب کنید.
            </main-text>
            <b-form-radio-group
              :checked="readyAppsSelectedVersion"
              :options="readyAppsSelectedItem.versions"
              value-field="id"
              text-field="version"
              @input="readyAppsSelectedVersionChanged"
            ></b-form-radio-group>
          </b-card>
          <b-card
            class="mb-3"
            v-if="
              readyAppsSelectedItem &&
                readyAppsSelectedItem.requiresFTDS &&
                userDbList.length > 0
            "
          >
            <template #header>
              <h4 class="m-0">
                انتخاب دیتابیس
              </h4>
            </template>
            <b-form-group>
              <b-form-radio-group
                v-model="typeSelectDb"
                :options="optionsTypeSelectDb"
                name="radio-type-select-db"
                @change="typeSelectDbChanged"
              />
            </b-form-group>
            <b-form-group v-if="typeSelectDb === 1">
              <b-form-radio-group
                :checked="userDbSelected"
                :options="userDbList"
                name="radio-select-db"
                value-field="id"
                text-field="name"
                @input="userDbSelectedChanged"
              />
            </b-form-group>
          </b-card>
        </b-tab>
      </b-tabs>
      <b-card class="mb-3">
        <template #header>
          <h4 class="m-0">
            شناسه سرویس
          </h4>
        </template>
        <main-text>
          لطفا یک شناسه‌ی یکتا به این سرویس اختصاص دهید.
        </main-text>
        <b-form-group>
          <b-input-group
            prepend="http://"
            append=".cv9.ir"
            style="direction: ltr;"
          >
            <b-form-input
              placeholder="Enter your service name ..."
              type="text"
              v-model="serviceName.value"
              @update="updateInput"
              @blur="blurInput"
              :state="validServiceName"
            />
          </b-input-group>
          <b-form-invalid-feedback class="text-right" :state="validServiceName">
            {{ serviceName.error }}
          </b-form-invalid-feedback>
          <b-form-invalid-feedback
            v-if="blurInputService"
            class="text-right"
            :state="duplicateServiceName"
          >
            {{ serviceName.error }}
          </b-form-invalid-feedback>
        </b-form-group>
        <main-text>
          <b-icon icon="exclamation-circle-fill" variant="warning"></b-icon>
          توسط این شناسه می‌توانید به برنامه خود دسترسی داشته باشید. برای مثال:
          <span class="text-primary">http://example.cv9.ir</span>
        </main-text>
      </b-card>
      <b-card class="mb-3">
        <template #header>
          <h4 class="m-0">
            ساخت پلن اختصاصی
          </h4>
        </template>
        <main-text>
          منابع اختصاصی مورد نظر خود را انتخاب کنید
          <span class="text-danger">
            (دقت داشته باشید که امکان تغییر فضا پس از ایجاد برنامه نیست)
          </span>
          .
        </main-text>
        <resource />
      </b-card>
      <b-card class="mb-3">
        <template #header>
          <h4 class="m-0">
            پشتیبان‌گیری خودکار
          </h4>
        </template>
        <b-form-group>
          <b-form-radio-group
            v-model="backupType"
            :options="backupOptions"
            @change="backupChangeHandler"
          />
        </b-form-group>
        <main-text>
          <b-icon icon="exclamation-circle-fill" variant="warning"></b-icon>
          هزینه پشتیبان‌گیری روزانه 4 برابر، پشتیبان‌گیری هفتگی 3 برابر و
          پشتیبان‌گیری ماهانه 2 برابر هزینه فضا محاسبه می‌شود.
        </main-text>
      </b-card>
      <!-- <h3 class="text-center text-success">هزینه کل: {{ mainPrice }} ریال</h3> -->
    </b-card>
    <b-form-group>
      <b-button
        variant="primary"
        @click="showCreateModal"
        :disabled="!stepCompelete"
      >
        ایجاد برنامه
      </b-button>
    </b-form-group>
    <create-app-modal
      :backupType="backupType"
      :visible="visibleCreateModal"
      @hidden="hiddenCreateModal"
      @show="showCreateModal"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import {
  SET_DEFAULT_STATE_SERVICE,
  SET_TYPE_SERVICE,
  UPDATE_SERVICE_NAME,
  BLUR_INPUT_SERVICE_NAME,
  //ready apps
  SET_READY_APPS_LIST,
  SELECT_READY_APPS,
  SET_READY_APP_SELECTED_VERSION,
  SET_USER_DB_LIST,
  SET_USER_DB_SELECTED,
  //custom apps
  SET_CUSTOM_APPS_LIST,
  SELECT_CUSTOM_APPS,
  SET_CUSTOM_APP_SELECTED_VERSION,
  TOTAL_PRICE_NUM
} from "@/store/mutation-types";
import MainText from "@/components/MainText/MainText.vue";
import Resource from "@/components/Resource/Resource.vue";
import Loading from "@/components/Loading/Loading.vue";
import ErrorMessages from "@/components/ErrorMessages/ErrorMessages.vue";
import CardApp from "@/components/CardApp/CardApp.vue";
import CreateAppModal from "./CreateAppModal.vue";
import { numberSpliter } from "../../../utils/functions";

export default {
  name: "AppCreate",
  components: {
    MainText,
    Resource,
    Loading,
    ErrorMessages,
    CardApp,
    CreateAppModal
  },
  data() {
    return {
      tabActive: null,
      stepCompelete: false,
      blurInputService: true,
      typeSelectDb: 0,
      optionsTypeSelectDb: [
        { text: "یک دیتابیس جدید می‌خواهم.", value: 0 },
        { text: "از دیتابیس‌های قبلی استفاده می‌کنم.", value: 1 }
      ],
      backupOptions: [
        { text: "نیاز ندارم", value: 1 },
        { text: "پشتیبان‌گیری روزانه", value: 2 },
        { text: "پشتیبان‌گیری هفتگی", value: 3 },
        { text: "پشتیبان‌گیری ماهانه", value: 4 }
      ],
      backupType: 1,
      backupPrice: 0,
      //create modal data
      visibleCreateModal: false
    };
  },
  computed: {
    mainPrice: function() {
      return numberSpliter(this[TOTAL_PRICE_NUM] + this.backupPrice);
    },
    ...mapGetters("resource", [TOTAL_PRICE_NUM]),
    ...mapState("resource", ["storage"]),
    ...mapState("service", [
      "serviceName",
      "validServiceName",
      "duplicateServiceName",
      //reafy apps
      "readyAppsLoading",
      "readyAppsErrorMessages",
      "readyAppsList",
      "readyAppsSelectedItem",
      "readyAppsSelectedVersion",
      "userDbList",
      "userDbSelected",
      //custom apps
      "customAppsLoading",
      "customAppsErrorMessages",
      "customAppsList",
      "customAppsSelectedItem",
      "customAppsSelectedVersion"
    ])
  },
  methods: {
    ...mapActions("service", [
      SET_DEFAULT_STATE_SERVICE,
      UPDATE_SERVICE_NAME,
      BLUR_INPUT_SERVICE_NAME,
      SET_TYPE_SERVICE,
      //ready apps
      SET_READY_APPS_LIST,
      SELECT_READY_APPS,
      SET_READY_APP_SELECTED_VERSION,
      SET_USER_DB_LIST,
      SET_USER_DB_SELECTED,
      //custom apps
      SET_CUSTOM_APPS_LIST,
      SELECT_CUSTOM_APPS,
      SET_CUSTOM_APP_SELECTED_VERSION
    ]),
    backupChangeHandler: function(val) {
      let totalPrice = this.storage.value * this.storage.pricePerUnit;
      switch (val) {
        case 1:
          this.backupPrice = totalPrice * 0;
          break;
        case 2:
          this.backupPrice = totalPrice * 4;
          break;
        case 3:
          this.backupPrice = totalPrice * 3;
          break;
        case 4:
          this.backupPrice = totalPrice * 2;
          break;
      }
    },
    tabsChanged: function(idTab) {
      this.tabActive = idTab;
      this[SET_TYPE_SERVICE](idTab === 1 ? "readyApp" : "customApp");
    },
    selectAppClicked: function(id) {
      if (this.tabActive === 1) this[SELECT_READY_APPS](id);
      else this[SELECT_CUSTOM_APPS](id);
    },
    updateInput: function(val) {
      this.blurInputService = false;
      this[UPDATE_SERVICE_NAME](val);
    },
    blurInput: function(e) {
      this.blurInputService = true;
      this[BLUR_INPUT_SERVICE_NAME](e.target.value);
    },
    //ready apps
    readyAppsSelectedVersionChanged: function(val) {
      this[SET_READY_APP_SELECTED_VERSION](val);
    },
    typeSelectDbChanged: function(val) {
      if (val === 0) {
        this[SET_USER_DB_SELECTED](null);
      }
    },
    userDbSelectedChanged: function(val) {
      this[SET_USER_DB_SELECTED](val);
    },
    //custom apps
    customAppsSelectedVersionChanged: function(val) {
      this[SET_CUSTOM_APP_SELECTED_VERSION](val);
    },
    // create modal method
    showCreateModal: function() {
      this.visibleCreateModal = true;
    },
    hiddenCreateModal: function() {
      document.getElementById("scroll-area").scrollTo(0, 0);
      this.visibleCreateModal = false;
    }
  },
  mounted() {
    this[SET_DEFAULT_STATE_SERVICE]();
    this[SET_USER_DB_LIST]();
    this[SET_READY_APPS_LIST]();
    this[SET_CUSTOM_APPS_LIST]();
    this[SET_TYPE_SERVICE]("customApp");
  },
  updated() {
    if (
      this.validServiceName &&
      !this.duplicateServiceName &&
      this.blurInputService
    ) {
      if (
        (this.tabActive === 0 && this.customAppsSelectedVersion !== "") ||
        (this.tabActive === 1 && this.readyAppsSelectedVersion !== "")
      ) {
        this.stepCompelete = true;
      }
    } else {
      this.stepCompelete = false;
    }
  }
};
</script>

<style></style>
